export default __webpack_public_path__ + "static/media/reprove-status-button.613d41c6.svg";